import { Stack, Typography } from '@mui/material';
import { Page } from '../../components';
import { useFlags } from '../../hooks';
import { useHistory, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

export const MaintenanceMode = () => {
  const history = useHistory();
  const { search } = useLocation();
  const { blMaintenanceMode } = useFlags();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const redirectToUrl = params.get('redirect');
    if (!blMaintenanceMode && redirectToUrl) {
      history.push(redirectToUrl);
    } else if (!blMaintenanceMode) {
      history.push(`/login`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blMaintenanceMode]);

  return (
    <Page title="Maintenance Mode" showUserMenu={false} showBreadcrumbs={false} showSideNav={false}>
      <Stack justifyContent="center" alignItems="center" gap={1} height="40rem" textAlign="center">
        <Typography component="h1" variant="h3" color="primary">
          Scheduled Maintenance
        </Typography>
        <Typography component="h2" variant="h4">
          BuilderLinq is currently unavailable due to system maintenance.
        </Typography>
        <Typography component="h3" variant="h5">
          Please try again later.
        </Typography>
      </Stack>
    </Page>
  );
};
